import { OIDC_CLIENT_ID, OIDC_ISSUER } from '../envs.js';
import Client from '@geoblocks/oidcjs';
import { PageKind, normalizeURL } from '../urlHandling/urlNormalizer.js';
import { resolveDeployPrefix } from '../initialization/deployPrefixResolver.js';
import { getLanguageCode } from '../i18n.js';
import { createMainURL } from '../urlHandling/urlCreate.js';
function createAppPostLogoutURL() {
    const l = document.location;
    const lang = getLanguageCode();
    const deployPrefix = resolveDeployPrefix();
    const normalized = normalizeURL(l.toString(), lang, 'summer', deployPrefix);
    switch (normalized.kind) {
        case PageKind.tours:
        case PageKind.tour:
        case PageKind.recordedtrack:
            return document.location.origin + createMainURL(lang);
        default:
            return document.location.toString();
    }
}
export function logoutFromSSO() {
    localStorage.setItem('appPostLogoutURL', createAppPostLogoutURL());
    oidcClient.logout(document);
}
export const oidcClient = new Client({
    redirectUri: typeof location === 'object'
        ? `${location.origin}/`
        : 'https://schweizmobil.ch/',
    clientId: OIDC_CLIENT_ID,
    pkce: true,
    scopes: ['openid', 'offline_access'],
    debug: true,
    checkToken: async () => {
        return true;
    },
}, {
    authorization_endpoint: `${OIDC_ISSUER}/authorize`,
    token_endpoint: `${OIDC_ISSUER}/token`,
    logout_endpoint: `${OIDC_ISSUER}/logout`,
    userinfo_endpoint: `${OIDC_ISSUER}/userinfo`,
});
//# sourceMappingURL=oidcClient.js.map